import React from "react";
import { ReactComponent as SavedSearchIcon } from "assets/icons/saved_search.svg";
import { ReactComponent as CreateCustomListIcon } from "assets/icons/create_custom_list.svg";
import { ReactComponent as SharingListIcon } from "assets/icons/sharing_list.svg";
import adOrganizerPage from "assets/images/4th.webp";
import adOrganizerPageReview from "assets/images/ad_organizer_page_review.png";
import RevealAnimationSection from "components/Animation/RevealAnimationSection";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";

const AdOrganizerSection = () => {
  const { openSignupDialog } = useDialog();
  const { user } = useAuth();

  return (
    <div className="px-5 py-10 lg:pt-[56px] lg:pb-[73px] lg:my-0 overflow-hidden">
      <RevealAnimationSection direction="left">
        {/* mobile heading  */}
        <h1 className="leading-normal lg:hidden mb-[25px] text-center font-bold text-[30px] ">
          L’<span className="text-primary">organizer</span> degli annunci
        </h1>
        <div className="grid items-center lg:grid-cols-2 gap-x-5">
          <div className="mr-[22px] lg:mr-0">
            <img
              className="h-full w-full"
              src={adOrganizerPage}
              alt="Ad Organizer Page"
            />
          </div>
          <div className="w-full">
            <div className="lg:max-w-[82%] ml-auto w-full flex flex-col items-center lg:items-start justify-center">
              <h1 className="leading-[48.41px] hidden lg:block font-bold text-[40px] ">
                L’<span className="text-primary">organizer</span> degli annunci
              </h1>
              <p className="text-[14px] lg:text-start text-center font-normal leading-[24px] lg:leading-[28px] mt-[25px] lg:mt-[18px]">
                Addio a file excel incompleti e caotici, HouseScan tiene traccia
                di tutte le tue ricerche e preferenze rendendo la gestione e il
                confronto delle proprietà un processo semplice e diretto.
              </p>
              <div className="mt-[20px] hidden lg:block">
                <div className="flex items-start space-x-[7px]">
                  <SavedSearchIcon />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Gestione Centralizzata delle Ricerche Salvate{" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Conserva tutte le proprietà di tuo interesse in un unico
                      posto grazie alla nostra estensione web, che permette di
                      salvare le proprietà anche da portali esterni.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-[7px] mt-[25px]">
                  <CreateCustomListIcon className="mt-[6px] min-w-[20px]" />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Creazione di Liste Personalizzate{" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Organizza le tue proprietà salvate in liste personalizzate
                      per categorizzare e priorizzare le tue ricerche secondo
                      criteri specifici.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-[7px] mt-[25px]">
                  <SharingListIcon className="mt-1" />
                  <div>
                    <h4 className="text-[16px] leading-[28px] font-bold">
                      Condivisione delle Liste{" "}
                    </h4>
                    <p className="text-[14px] font-normal leading-[28px]">
                      Collabora facilmente con altri utenti, amici o familiari
                      condividendo le tue liste personalizzate.
                    </p>
                  </div>
                </div>
              </div>
              {!user && (
                <button
                  onClick={openSignupDialog}
                  className="lg:mt-5 mt-[25px] shadow-sm w-[154px] lg:w-[247px] h-[47px] lg:h-[55px] flex items-center justify-center border-[1px] border-[#4AB4F5] hover:bg-transparent rounded-[4px] font-semibold hover:text-primary text-[14px] bg-[#1DA1F2] text-white transition-all duration-400 ease-linear"
                >
                  ISCRIVITI
                </button>
              )}
            </div>
          </div>
        </div>
      </RevealAnimationSection>
    </div>
  );
};

export default AdOrganizerSection;
